import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';
import { Link } from '@tcc/crate';
import { FIELD_VIEW_URL } from 'constants/urls';

const baseString = 'vra-harvest-history-upload-yield-info';
const classString = classNames({
  [`${baseString}`]: true
});

const UploadYieldInfo = ({ text }) => (
  <section className={classString}>
    <p>
      {text}
      <Link href={FIELD_VIEW_URL.DATA_INBOX} target='_blank'>
        {' '}{getMessage(`link-text__upload-yield`)}
      </Link>
    </p>
  </section>
);

UploadYieldInfo.propTypes = {
  text: propTypes.string.isRequired
};

export default UploadYieldInfo;
